var React = require('react');

function WindowMinimize (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z","className":"fa-secondary","key":1})]);
}

WindowMinimize.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = WindowMinimize;

WindowMinimize.default = WindowMinimize;
